/**
 * Get user's subscription status
 * Includes: active subscription, pending requests, tier, expiry info
 */
export const getSubscriptionStatus = async () => {
  const response = await fetch("/api/subscription/status", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch subscription status");
  }

  return response.json();
};

/**
 * Create a new subscription request
 */
export const createSubscriptionRequest = async (planId, billingInterval) => {
  const response = await fetch("/api/subscription/request", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      planId,
      billingInterval,
    }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw error;
  }

  return response.json();
};

/**
 * Request subscription renewal
 */
export const renewSubscription = async (billingInterval) => {
  const response = await fetch("/api/subscription/renew", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      billingInterval,
    }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw error;
  }

  return response.json();
};

/**
 * Get subscription request history
 */
export const getSubscriptionHistory = async () => {
  const response = await fetch("/api/subscription/history", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch subscription history");
  }

  return response.json();
};
